/**
 * Tiny leaf holding the active session's tenant so low-level utilities (e.g.
 * JobPersistenceService) can scope persisted data by environment WITHOUT importing
 * the redux store.
 *
 * The store is the composition root and already imports JobPersistenceService, so
 * a reverse import (util → store) would form a module-load cycle and leave the
 * store's rootReducer undefined at creation. Instead the store PUSHES the tenant
 * in here via a subscriber wired at store/index.js, and consumers only READ it.
 *
 * This module imports nothing on purpose — it can never be part of an import cycle.
 */
let _tenant = null;

/** Called by the store subscriber whenever the active tenant changes. */
export function setSessionTenant(tenant) {
  _tenant = tenant || null;
}

/** Active tenant name, or null before the session is hydrated. */
export function getSessionTenant() {
  return _tenant;
}
